import React from "react";

const steps = [
  "Connect Data Sources",
  "Transform & Clean Data",
  "Build Data Pipeline",
  "Visualize Insights",
  "AI Predictions"
];

const Pipeline = () => (
  <section id="pipeline" className="py-20 bg-white text-center px-6">
    <h2 className="text-3xl font-bold mb-12">How It Works</h2>
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-8">
      {steps.map((step, i) => (
        <div
          key={i}
          data-aos="zoom-in"
          className="p-6 bg-[#f9f6ff] border rounded-xl shadow hover:shadow-lg transition"
        >
          <div className="text-5xl text-indigo-600 font-bold mb-4">
            {i + 1}
          </div>
          <h3 className="text-lg font-semibold">{step}</h3>
        </div>
      ))}
    </div>
  </section>
);

export default Pipeline;
